import { combine } from 'effector'
import { model as i18n } from '~/core/i18n'

export const $playerGoLivePopupTranslations = combine(i18n.$t, ({ t }) => ({
  title: t('paused_content_no_available_message'),
  go_live_button: t('go_live'),
  go_to_events_button: t('go_to_events_button'),
}))
